// extracted by mini-css-extract-plugin
module.exports = {"form":"AddNew_form__T1FNQ","row":"AddNew_row__68rwd"};